module.exports = __webpack_public_path__ + "img/ic3-respaldos.7fca111f.jpg";